import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LangCtx = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

const lookup = (dict, path) =>
  path.split(".").reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), dict);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem("qsafe-lang") || "en"; } catch { return "en"; }
  });

  useEffect(() => {
    try { localStorage.setItem("qsafe-lang", lang); } catch {}
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) =>
    lookup(translations[lang], path) ?? lookup(translations.en, path) ?? path;

  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
